<template>
	<div class="card">
		<div class="card-body p-0">
			<preloader v-if="loadingStore"></preloader>
			<div class="p-3">
				<div class="fixed-action-btn">
		            <button type="button" class="btn btn-primary btn-floating btn-large" tooltip="Crear Oportunidad" :disabled="!validateData" v-on:click="storeOportunidad()">
		                <i class="material-icons">save</i>
		            </button>
		        </div>

				<div class="form-row">
		            <div class="col-md-4 mb-2">
		                <label>Nombre Cliente:</label>
		                <input type="text" class="form-control form-control-sm" maxlength="100" v-model="form.name">
		                <div 
		            		class="text-danger" 
		            		v-if="errorsClient.name">
		            		<small class="ml-1">{{errorsClient.name}}</small>
		            	</div>
		            	<div v-if="errors && errors.name" class="text-danger">
	                        {{ errors.name[0] }}
	                    </div>
		            </div>

		            <div class="col-md-4 mb-2">
		                <label>Teléfono:</label>
		                <phone class="form-control-sm" v-model="form.telefono" :isValid="isValidTel" @inputValues="onInput"></phone>
		                <div 
		            		class="text-danger" 
		            		v-if="errorsClient.telefono">
		            		<small class="ml-1">{{errorsClient.telefono}}</small>
		            	</div>
		            	<div v-if="errors && errors.telefono" class="text-danger">
	                        {{ errors.telefono[0] }}
	                    </div>
		            </div>

		            <div class="col-md-4 mb-2">
		                <label>Correo electrónico:</label>
		                <input type="email" class="form-control form-control-sm" maxlength="125" v-model="form.correo">
		                <div 
		            		class="text-danger" 
		            		v-if="errorsClient.correo">
		            		<small class="ml-1">{{errorsClient.correo}}</small>
		            	</div>
		            	<div v-if="errors && errors.correo" class="text-danger">
	                        {{ errors.correo[0] }}
	                    </div>
		            </div>

		            <div class="col-md-6 mb-3" v-if="role!='V'">
		            	<div>
		           			<label>Vendedor:</label>
		            		<div :class="{'custom-control custom-checkbox':true, 'float-right':!clientAuto}">
								<input type="checkbox" class="custom-control-input" id="checkVendedor" v-model="clientAuto">
								<label class="custom-control-label" for="checkVendedor">
									<span v-if="clientAuto">Vendedor </span>Automático</label>
							</div>
		            	</div>
		           		<catalogo-vendedores v-model="form.vendedor" v-if="!clientAuto"></catalogo-vendedores>
		           		<div v-if="errors && errors.vendedor" class="text-danger">
	                        {{ errors.vendedor[0] }}
	                    </div>
		            </div>
		        </div>

				<h5>Detalle</h5>
			    <div class="form-row align-items-end">
			        <div class="col-7">
			            <label>Producto:</label>
			            <div class="input-group input-group-sm flex-nowrap">
							<select2 :disabled="loading" v-model="detalle.producto">
								<option v-for="producto in productos" v-bind:value="producto.CODIGO_PRODUCTO">
									{{producto.DESCRIPCION_PRODUCTO}}
								</option>
							</select2>
							<div class="input-group-append" v-if="productos.length==0">
								<button class="btn btn-outline-secondary" type="button"  v-on:click.prevent="getProductos" tabindex="-1">
									<span v-if="loading">
						    			<i class="fas fa-spinner fa-pulse"></i>
									</span>
									<i class="material-icons" style="font-size: 18px;" v-else>update</i>
								</button>
							</div>
						</div>
			        </div>
			        <div class="col-3">
			            <label>Precio:</label>
			            <decimal class="form-control-sm" v-model="detalle.precio" min="0"></decimal>
			        </div>
			        <div class="col-2 text-right">
			            <button type="button" class="btn btn-light btn-sm" v-on:click="addDetails" :disabled="detalle.producto == ''">
			                <i class="material-icons">add</i> <span class="d-none d-md-inline-block">Agregar detalle</span>
			            </button>
			        </div>
			    </div>
			    <div class="form-row mt-3" v-if="form.detalles.length>0">
			    	<table class="table table-sm table-borderless table-hover table-striped">
			    		<thead>
			    			<tr>
								<td colspan="3" class="p-1">
									<div class="text-muted text-uppercase font-weight-bolder text-monospace text-left">
										Productos ({{form.detalles.length}})
									</div>
								</td>
							</tr>
			    		</thead>
			    		<tbody>
			    			<tr v-for="(detalle, index) in form.detalles" class="cursor-pointer">
			    				<td>
			    					{{detalle.producto}} - {{detalle.descripcion}}
			    					<input type="text" :name="'detalles['+index+'][producto]'" v-model="detalle.producto" class="d-none">
			    				</td>
			    				<td align="right">
			    					<input type="text" :name="'detalles['+index+'][precio]'" v-model="detalle.precio" class="d-none">
			    					{{money(detalle.precio, true)}}
			    				</td>
			    				<td width="50px" align="right">
			    					<div class="table-hover-options">
				    					<button class="text-muted ml-2 p-1" v-on:click.stop="deleteDetails(index)" style="background-color: transparent; border: 0px;">
				    						<i class="material-icons">delete</i>
				    					</button>
			    					</div>
			    				</td>
			    			</tr>
			    		</tbody>
			    	</table>
			    </div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return {
				detalle: {
					producto: '',
					precio: 0
				},

				errorsClient: {
					name: '',
					telefono: '',
					correo: ''
				},

				errors: {},

				form: {
					name: '',
					telefono: '',
					correo: '',
					vendedor: '',
					detalles: [],
				},

				clientAuto: true,
				isValidTel: false,
				productos: [],
				loading: false,
				loadingStore: false
			}
		},

		mounted(){
			this.getProductos()
		},

		methods: {
			getProductos: function(){
				this.loading = true
				var url = 'api/catalogos/productos'

				axios.get(url)
				.then(response => {
					this.productos = response.data
				}).catch(error => {
					console.log(error.response)
				}).then(()=>{
					this.loading = false
				})
			},

			addDetails: function(){
				var descripcion = this.productos.filter(x => x.CODIGO_PRODUCTO == this.detalle.producto)[0]['DESCRIPCION_PRODUCTO'] || ''

				this.form.detalles.push({
					'producto': this.detalle.producto,
					'descripcion': descripcion,
					'precio': this.detalle.precio
				})
				this.detalle.producto = ''
				this.detalle.precio = 0
			},

			storeOportunidad: function(){
				this.loadingStore = true

				axios.post(`oportunidades/rapidas/store`, {
					name: this.form.name,
					telefono: this.form.telefono,
					correo: this.form.correo,
					vendedor: this.form.vendedor,
					detalles: this.form.detalles
				})
				.then(response => {
					this.$toasted.show('La oportunidad ha sido creada.');
					location.href = crm.route.home
				}).catch(error => {
					console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show('Error al crear oportunidad.');
				}).then(()=>{
					this.loadingStore = false
				})
			},

			deleteDetails: function(index){
				this.form.detalles.splice(index, 1)
			},

			validEmail: function (email) {
		    	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		     	return re.test(email)
		    },

		    onInput: function({number, isValid, country}){
		    	this.isValidTel = isValid
		    }
		},

		computed: {
			validateData: function(){
				var val = true
				if (this.form.name == '') {
					this.errorsClient.name = 'Se requiere información.'
					val = false
				}else{
					this.errorsClient.name = ''
				}

				if (this.form.correo != '') {
					if (!this.validEmail(this.form.correo)) {
						this.errorsClient.correo = 'Correo no válido.'
						val = false
					}else{
						this.errorsClient.correo = ''
					}
				}else{
					this.errorsClient.correo = ''
				}

				if (this.form.telefono != '') {
					if(!this.isValidTel){
						this.errorsClient.telefono = 'Teléfono no válido.'
						val = false
					}else{
						this.errorsClient.telefono = ''
					}
				}else{
					this.errorsClient.telefono = ''
				}

				return val
			},

			role: function(){
				return crm.role
			}
		}
	}
</script>